import React from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { filterableYears } from '../../DocumentVault.meta';
import { setFidelityFilterableYearOption } from '../../state/actions';
import { useFilterableYearOption } from '../../state/selectors';
import { useRouteParams } from '../../hooks/useRouteParams';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';

export const DatePicker = () => {
  const { filterableByYear } = useRouteParams();

  if (!filterableByYear) {
    return null;
  }

  return <DatePickerContent />;
};

const DatePickerContent = () => {
  const selectedYearOption = useFilterableYearOption();

  const { forceYear, setForceYear } = useDocumentVaultContext();

  const forceYearOption = forceYear ? { value: forceYear, label: forceYear.toString() } : null;

  const dispatch = useDispatch();

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Text variant="formLabel" mr="8">
        Year
      </Text>

      <Select
        size="large"
        value={forceYearOption || selectedYearOption}
        options={filterableYears}
        defaultValue={filterableYears[0]}
        onChange={opt => {
          if (opt) {
            // We need to clear the forceYear
            setForceYear(null);

            dispatch(setFidelityFilterableYearOption({ fidelityFilterableYearOption: opt }));
          }
        }}
      />
    </Box>
  );
};
